import React, { useState, useEffect } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Legend } from "recharts";
import { useMediaQuery } from "react-responsive";
import { useSelector } from "react-redux";
import { numberWithCommas } from "../../utils";

const RADIAN = Math.PI / 180;
// const data = [
//   { name: "Filled", value: 63, color: "#4F81BD" },
//   { name: "Unfilled", value: 37, color: "#D6E1F5" },
// ];
const cx = "50%";
const cy = 100;
const iR = 80;
const oR = 100;
const value = 63;

const IrrigatedArea = ({ activeBtn }) => {
  const { dashboardData } = useSelector((state) => state.fetch);
  const isSmallScreen = useMediaQuery({ maxWidth: 768 });

  const url = "api/v2/dashboard/getAllDashboardData";

  const data = useSelector((state) => state.fetch.data[url] || []);

  const total = data?.landIrrigation?.reduce(
    (acc, curr) => acc + curr?.value,
    0
  );

  const totalLandSize = data?.landIrrigation?.find(
    (item) => item?.name === "Total Developed Area"
  )?.value;
  const totalIrrigatedArea = data?.landIrrigation?.find(
    (item) => item?.name === "Total Irrigated Area"
  )?.value;

  const percentage =
    totalLandSize && totalIrrigatedArea
      ? (totalIrrigatedArea / totalLandSize) * 100
      : 0;

  const [animatedValue, setAnimatedValue] = useState(0);

  const irrigated = totalIrrigatedArea || 0;
  const nonIrrigated = totalLandSize ? totalLandSize - irrigated : 0;

  const irrigationPieData = [
    { name: "Irrigated Area", value: irrigated, color: "#4F81BD" },
    { name: "Non-Irrigated Area", value: nonIrrigated, color: "#D6E1F5" },
  ];

  return (
    <div className="p-[1.25rem] rounded-[.75rem] bg-white  w-full h-full">
      <div className="flex justify-between mb-[3rem]">
        {data?.landIrrigation &&
          data?.landIrrigation?.map((item) => (
            <div className="flex flex-col">
              <span
                className={`text-[#424242] text-[.75rem] font-[500] font-interSans`}
              >
                {item?.name}
              </span>
              <span
                style={{ color: item?.color }}
                className={`font-[500] text-[1rem] font-interSans`}
              >
                {numberWithCommas(item?.value)}
              </span>
            </div>
          ))}
      </div>

      <ResponsiveContainer width="100%" height={200}>
        <PieChart>
          <Pie
            dataKey="value"
            startAngle={180}
            endAngle={0}
            data={irrigationPieData}
            cx="50%"
            cy="50%"
            innerRadius={iR}
            outerRadius={oR}
            stroke="none"
          >
            {irrigationPieData?.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>

          <text
            x="50%"
            y="50%"
            textAnchor="middle"
            dominantBaseline="middle"
            fontSize={16}
            fill="#000"
          >
            <tspan x="50%" dy="-1.5em">
              {`${Math.round(percentage)}%`}
            </tspan>
            <tspan x="50%" dy="1.2em" fill="#706F6F">
              Irrigated Area
            </tspan>
          </text>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default IrrigatedArea;
